<template>
    <ContentOrLoading>
        <VentaDiariaComponent v-if="venta_diaria" :valores="valores_venta_diaria_grafica"/>
    </ContentOrLoading>
</template>

<script>
    import VentaDiariaComponent from '@/components/backend/estadisticas/common/VentaDiariaComponent';
    export default {
        props: ['lista_id', 'fecha_inicio', 'fecha_fin'],
        data() {
            return {
                loading: false,
                venta_diaria: null,
                valores_venta_diaria_grafica: null
            }
        },
        methods: {
            getVentaDiaria() {
                this.loading = true;

                const params = {
                    filters : {},
                    lista_id: this.lista_id
                };

                if (this.fecha_inicio && this.fecha_fin) {
                    params.filters.fecha_inicio = this.fecha_inicio;
                    params.filters.fecha_fin = this.fecha_fin;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.informe.venta-diaria'), params).then(res => {
                    this.venta_diaria = res.data.data;
                    this.montarGraficoVentaDiaria();
                }).finally(() => this.loading = false);
            },
            montarGraficoVentaDiaria(){
                var valores = [];

                valores.push(['Fecha', 'Ventas']);

                for(var i in this.venta_diaria) {
                    valores.push([this.venta_diaria[i].fecha, this.venta_diaria[i].total]);
                }

                this.valores_venta_diaria_grafica = valores;
            },
        },
        created() {
            this.getVentaDiaria();
        },
        components: {
            VentaDiariaComponent
        }
    }
</script>